import { makeStyles } from '@mui/styles';
import ButtonGroup from 'apollo-react/components/ButtonGroup/ButtonGroup';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { CacheListTable } from './CacheListTable';
import { handleErrors } from '../../actions/ErrorActions';
import { addSuccess } from '../../actions/SuccessActions';
import { cleanupCaches, getCacheList } from '../../api/cache-list';
import DefaultPageLayout from '../../components/DefaultPageLayout';
import * as Urls from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  buttonsContainer: {
    marginTop: 15,
  },
});

const CachesListPage = () => {
  const translateString = useTranslation();
  const title = translateString('Cache List');
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [cacheListItems, setCacheListItems] = useState([]);
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    document.title = title;

    const loadCacheListData = async () => {
      setIsLoading(true);
      const response = await getCacheList();
      if (!response.hasError) {
        const { CacheList = [] } = response;
        const convertedCacheListItems = CacheList.map((item) => ({ cache: item }));
        setCacheListItems(convertedCacheListItems);
      } else {
        dispatch(handleErrors(response.errors));
      }
      setIsLoading(false);
    };

    loadCacheListData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clearAllClickHandler = async () => {
    setIsLoading(true);
    const response = await cleanupCaches();
    if (!response.hasError) {
      dispatch(addSuccess({ message: translateString('Caches have been successfully cleared') }));
    } else {
      dispatch(handleErrors(response.errors));
    }
    setIsLoading(false);
  };

  const cancelClickHandler = () => {
    history.push(Urls.HOME);
  };

  return (
    <DefaultPageLayout pageTitle={title}>
      <CacheListTable isLoading={isLoading} cacheListItems={cacheListItems} />
      <ButtonGroup
        alignItems="right"
        className={classes.buttonsContainer}
        buttonProps={[
          {
            label: translateString('Cancel'),
            onClick: cancelClickHandler,
          },
          {
            label: translateString('Clear All'),
            onClick: clearAllClickHandler,
            disabled: isLoading || !cacheListItems.length,
          },
        ]}
      />
    </DefaultPageLayout>
  );
};

export default CachesListPage;
